import { useSelector } from 'react-redux';

import { versionComparisonSelector } from '../../../store/audit/selectors';
import useComparisonParams from './useComparisonParams';

function useComparisonValues({ path, value }: { path: string; value: string | number | null | undefined }) {
  const { leftEpochMillis, rightEpochMillis } = useComparisonParams();
  const { differenceMap } = useSelector(versionComparisonSelector);

  const valueHasChanged = !!differenceMap[path];

  const oldValue =
    Number(leftEpochMillis) > Number(rightEpochMillis) && valueHasChanged ? differenceMap[path]!.rightValue : value;
  const newValue =
    Number(leftEpochMillis) < Number(rightEpochMillis) && valueHasChanged ? differenceMap[path]!.rightValue : value;

  return {
    oldValue,
    newValue,
    valueHasChanged,
  };
}

export default useComparisonValues;
